import { FC } from "react"

import SectionCell from "../../../../../section/cell"
import { Lead } from "../../../../../../../types"

interface Props {
  data: Lead
}

const Message: FC<Props> = ({ data }) => {
  const {
    details: { message = "" }
  } = data

  return (
    <SectionCell
      className="-mt-12 break-all"
      label=""
      value={message}
      noFixedHeight
    />
  )
}

export default Message
